import * as React from 'react';
const SvgStopRounded = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path d="M14 4a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2V4z" fill="currentColor" />
    </svg>
);
export default SvgStopRounded;
